import React from 'react';
import { cn } from '../../utils/cn';

export interface FormSectionProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

const FormSection: React.FC<FormSectionProps> = ({ title, description, children, className }) => {
  return (
    <section className={cn('flex flex-col gap-4', className)}>
      {(title || description) && (
        <div className="flex flex-col gap-1">
          {title && (
            <h2 className="text-xs font-semibold uppercase tracking-widest text-[var(--muted-foreground)]">
              {title}
            </h2>
          )}
          {description && <p className="text-sm text-[var(--muted-foreground)]">{description}</p>}
        </div>
      )}
      <div className="grid gap-4">{children}</div>
    </section>
  );
};

export default FormSection;
